export enum MessageType {
    WIN = 'win',
    INFO = 'info',
    WARNING = 'warning',
}
